import { UpdateUserInfoRequestSchema } from "../schemas/requests/users";
import { BaseUserSchema, GetUsersResponseSchema, MeSchema } from "../schemas/responses/users";
import requestApi from "../fetchApi";

export class UsersApi {
    static apiPrefix = "/api/users";

    static async all(): Promise<MeSchema[]> {
        return requestApi.GET(`${this.apiPrefix}`).then((data: GetUsersResponseSchema) => {
            return data.users;
        });
    }

    static async findByName(name: string): Promise<BaseUserSchema[]>{
        return requestApi.GET(`${this.apiPrefix}?name=${name}`);
    }

    static async getMe(): Promise<MeSchema> {
        return requestApi.GET(`${this.apiPrefix}/me`);
    }

    static async updateUserInfo(userId: number, data: UpdateUserInfoRequestSchema) {
        return await requestApi.PUT(`${this.apiPrefix}`, { body: data });
    }

    static async checkLoginUniqueness(login: string): Promise<boolean> {
        return await requestApi.GET(`${this.apiPrefix}/names/${login}`);
    }
}
